import request from '@/utils/request';

/**
 * 获取页面详情接口
 * @param {*} data 请求对象 需要 mobile 和 password
 * @returns Promise
 */
export function getPageData(params) {
  return request({
    method: 'get',
    url: '/meeting/modular/detail',
    params,
  });
}

/**
 * 获取直播详情
 * @param {*} data 请求对象 需要 mobile 和 password
 * @returns Promise
 */
export function geiVideodetail(params) {
  return request({
    method: 'get',
    url: '/meeting/live/detail',
    params,
  });
}

/**
 * 获取直播签到
 * @param {*} data 请求对象 需要 mobile 和 password
 * @returns Promise
 */
export function geiVideoForm(params) {
  return request({
    method: 'get',
    url: '/meeting/live/form',
    params,
  });
}


/**
 * 提交表单数据
 * @param {*} data 请求对象 需要 mobile 和 password
 * @returns Promise
 */
export function createForm(data) {
  return request({
    method: 'post',
    url: '/meeting/form/signIn',
    data
  })
}

/**
 * 获取云展台详情
 * @param {*} data 请求对象 需要 mobile 和 password
 * @returns Promise
 */
export function geiYunDetail(params) {
  return request({
    method: 'get',
    url: '/meeting/video/detail',
    params,
  });
}

/**
 * 获取图文详情
 * @param {*} data 请求参数
 * @returns Promise
 */
export function getDocumentDet(params) {
  return request({
    method: 'get',
    url: '/meeting/material/document/detail',
    params,
  });
}

/**
 * 获取专家列表
 * @param {*} data 请求参数
 * @returns Promise
 */
export function getSpecialist(params) {
  return request({
    method: 'get',
    url: '/meeting/frontend/specialist/list',
    params,
  });
}

/**
 * 获取专家详情
 * @param {*} data 请求参数
 * @returns Promise
 */
export function getSpecialistDec(params) {
  return request({
    method: 'get',
    url: '/meeting/frontend/specialist/detail',
    params,
  });
}